import React from 'react';
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    withStyles,
    FormHelperText
} from '@material-ui/core';
import { enabledField } from '../index';
import { isSuperUser } from '../../../sc-utilities';

const styles = (theme) => ({
    formControl: {
        width: '100%',
    },
});

const PresetGeneralSettings = (props) => {
    const { classes, translations, handleChange, values, orders, collies, setFieldValue, grades, printers } = props;

    const fieldNames = {
        PresetsEnabled: `PresetsEnabled`,
        AutoEnableRemoteAccess: `AutoEnableRemoteAccess`,
        AutoStartErasure: `AutoStartErasure`,
        AutoStartDiagnose: `AutoStartDiagnose`,
        OrderID: `OrderID`,
        TransportColliID: `TransportColliID`,
        ColliID: `ColliID`,
        PrinterID: `PrinterID`,
        AutoGradingFromTypicalProblems: `AutoGradingFromTypicalProblems`,
        GradeID: `GradeID`,
        ProcessingSessionEndMessage: `ProcessingSessionEndMessage`,
        DebugMode: `DebugMode`,
    };

    const fieldValues = {
        PresetsEnabled: values['PresetsEnabled'],
        AutoEnableRemoteAccess: values['AutoEnableRemoteAccess'],
        AutoStartErasure: values['AutoStartErasure'],
        AutoStartDiagnose: values['AutoStartDiagnose'],
        OrderID: values['OrderID'],
        TransportColliID: values['TransportColliID'],
        ColliID: values['ColliID'],
        PrinterID: values['PrinterID'],
        AutoGradingFromTypicalProblems: values['AutoGradingFromTypicalProblems'],
        GradeID: values['GradeID'],
        ProcessingSessionEndMessage: values['ProcessingSessionEndMessage'],
        DebugMode: values['DebugMode'],
    };

    return (
        <>
            <Typography align="center" variant={'h5'}>
                {translations['general_presets'] || 'General Presets'}
            </Typography>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['PresetsEnabled']}
                            checked={fieldValues['PresetsEnabled'] || false}
                            onChange={handleChange}
                        />
                    }
                    label={`${translations['enable_preset'] || 'Enable preset'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoEnableRemoteAccess']}
                            checked={fieldValues['AutoEnableRemoteAccess'] || false}
                            disabled={enabledField(values)}
                            onChange={handleChange}
                        />
                    }
                    label={translations['auto_enable_remote_access'] || 'Auto enable remote access'}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoStartErasure']}
                            checked={fieldValues['AutoStartErasure'] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['autostart_erasure'] || 'Autostart erasure'}`}
                />
            </FormGroup>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoStartDiagnose']}
                            checked={fieldValues['AutoStartDiagnose'] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['autostart_diagnose'] || 'Autostart diagnose'}`}
                />
            </FormGroup>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['order_select'] || 'Please select order'}</InputLabel>
                <Select
                    name={fieldNames['OrderID']}
                    value={fieldValues['OrderID']}
                    label={translations['order'] || 'Order'}
                    margin={'dense'}
                    onChange={(event) => {
                        setFieldValue(fieldNames['TransportColliID'], '');
                        handleChange(event);
                        return event.stopPropagation();
                    }}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations['list_view'] || 'List view'}</em>
                    </MenuItem>
                    {(orders ? orders : []).map((option) => (
                        <MenuItem key={option.OrderID} value={option.OrderID}>
                            {option.Name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>
                    {translations['transport_colli_text'] || 'Please select transport colli'}
                </InputLabel>
                <Select
                    name={fieldNames['TransportColliID']}
                    label={translations['transport_colli'] || 'Transport Colli'}
                    margin={'dense'}
                    value={fieldValues['TransportColliID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations['list_view'] || 'List view'}</em>
                    </MenuItem>
                    {(orders?.length > 0
                        ? orders.filter((order) =>
                              order.OrderID === fieldValues['OrderID'] ? fieldValues['OrderID'] : ''
                          )
                        : []
                    ).map((order) => {
                        return order.TransportCollies.map((option) => (
                            <MenuItem key={option.TransportColliID} value={option.TransportColliID}>
                                {option.Name}
                            </MenuItem>
                        ));
                    })}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['colli_text'] || 'Please select container'}</InputLabel>
                <Select
                    name={fieldNames['ColliID']}
                    label={translations['colli'] || 'Colli'}
                    margin={'dense'}
                    value={fieldValues['ColliID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    <MenuItem value="">
                        <em>{translations['list_view'] || 'List view'}</em>
                    </MenuItem>
                    {(collies ? collies : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['printers_text'] || 'Please select printer'}</InputLabel>
                <Select
                    name={fieldNames['PrinterID']}
                    label={translations['printers'] || 'Printers'}
                    margin={'dense'}
                    value={fieldValues['PrinterID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(printers ? printers : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox
                            color={'primary'}
                            margin={'dense'}
                            name={fieldNames['AutoGradingFromTypicalProblems']}
                            checked={fieldValues['AutoGradingFromTypicalProblems'] || false}
                            onChange={handleChange}
                            disabled={enabledField(values)}
                        />
                    }
                    label={`${translations['auto_grade_from_typical_problems'] || 'Auto-grade from Typical Problems'}`}
                />
            </FormGroup>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['grade_text'] || 'Please select grade'}</InputLabel>
                <Select
                    name={fieldNames['GradeID']}
                    label={translations['grade'] || 'Grade'}
                    margin={'dense'}
                    defaultValue={''}
                    value={fieldValues['GradeID']}
                    onChange={handleChange}
                    disabled={enabledField(values)}
                >
                    {(grades ? grades : []).map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                name={fieldNames['ProcessingSessionEndMessage']}
                value={fieldValues['ProcessingSessionEndMessage'] || ''}
                onChange={handleChange}
                placeholder={translations['processing_session_end_message'] || 'Processing session end message'}
                label={translations['processing_session_end_message'] || 'Processing session end message'}
                margin={'dense'}
                fullWidth={true}
                multiline
                disabled={enabledField(values)}
            />
            {isSuperUser() ? 
                <FormGroup>
                    <FormControl className={classes.formControl} margin={'dense'}>
                        <TextField
                            name={fieldNames['DebugMode']}
                            value={fieldValues['DebugMode']}
                            label={`${translations['debug_mode'] || 'Debug mode'}`}
                            margin={'dense'}
                            fullWidth
                            onChange={handleChange}
                            placeholder={translations['debug_mode'] || 'Debug mode'}

                        />
                    </FormControl>
                    <FormHelperText>
                        Combine modes with + (for example 1+5); a parameter follows a colon (for example 95:1234).
                        <ul>
                            <li>0 - OFF, default</li>
                            <li>1 - auto send system report (on logout/shutdown)</li>
                            <li>2 - detailed device info (work - device/storage info in the log, mobile - logs from adb/idevicedebug as well)</li>
                            <li>2:connect / 2:full - mobile: phone logs from plug-in on / iPhone logs with SpringBoard and kernel</li>
                            <li>3 - autopilot: always send the device hash (debug collection) (work)</li>
                            <li>4 / 4:all - server digest: a small report after the analysis and each erasure run - servers only, with "all" every machine (work)</li>
                            <li>5 - record every workflow run in full, for replay in the workflow editor (work, mobile - testing)</li>
                            <li>90 - retired - automatic grading is now switched by the preset</li>
                            <li>91 - enable reimaging - reinstall Windows after erase (work)</li>
                            <li>92 - AirPods: advanced diagnose (mobile on macOS)</li>
                            <li>93 - a grade is required before the session can end (work, mobile)</li>
                            <li>94 - AI grading and the Motion preview features (mobile, motion)</li>
                            <li>95:PIN - open the station in a browser in the same network, with this PIN (work, mobile)</li>
                            <li>96 - ATA Secure Erase reuses the verify pattern already written (work - testing)</li>
                            <li>97 - Erase + Repair after a firmware Purge (work - testing, changes the drive)</li>
                            <li>98 - expander view: the server as a map of its bays (work - testing)</li>
                            <li>99 - spin down idle drives (work - testing)</li>
                        </ul>
                    </FormHelperText>
                </FormGroup>
            : null}
        </>
    );
};

export default withStyles(styles, { withTheme: true })(PresetGeneralSettings);
